import { Outlet, Navigate } from 'react-router-dom';

const PrivateRoute = () => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("User-Role");

    return (token) ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoute;
